import React from "react";
import ReactDOM from "react-dom/client";
import { Providers } from "./Providers";

import "./utils/analytics/initAnalytics";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Providers />
  </React.StrictMode>,
);
